// extracted by css-extract-rspack-plugin
export default {"cls1":"ExportFormatModal-cls1_s7x","cls2":"ExportFormatModal-cls2_lra ExportFormatModal-cls1_s7x"};